<template>
    <div class="app-header" :class="headerClasses">
        <layout-contained>
            <div class="flex justify-between py-2 text-2xl">
                <nuxt-link :aria-label="$config.public.siteName" to="/">
                    <picture>
                        <source :srcset="$config.public.images + $config.public.siteLogoAvif" type="image/avif" media />
                        <source :srcset="$config.public.images + $config.public.siteLogoWebp" type="image/webp" media />
                        <img :src="$config.public.images + $config.public.siteLogo" width="158" height="60" alt />
                    </picture>
                </nuxt-link>
                <div class="grow"></div>
                <app-header-menu></app-header-menu>
                <app-header-hamburger-menu></app-header-hamburger-menu>
                <app-header-hamburger></app-header-hamburger>
            </div>
        </layout-contained>
    </div>
</template>

<script>
export default {
    name: 'AppHeader',
    computed: {
        headerOverlay() {
            return this.$route.name === 'index';
        },
        headerClasses() {
            const cls = {};
            cls['absolute w-full z-10'] = !!this.headerOverlay;
            cls['bg-zinc-800'] = !this.headerOverlay;
            return cls;
        },
    },
};
</script>
